import type React from 'react'

type MarginsLayoutProps = {
  children: React.ReactNode
}

export function MarginsLayout({ children }: MarginsLayoutProps) {
  return <div className='mx-auto min-w-0 max-w-xl lg:max-w-7xl'>{children}</div>
}
